"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLineControl = withLineControl;
async function withLineControl(transport, options, initLogic) {
    const { setDtr = false, setRts = false, sendPulse } = options;
    await transport.purge();
    const pulseTransport = transport;
    if (sendPulse && pulseTransport.sendPulse) {
        await sendPulse(pulseTransport);
        return;
    }
    if (setDtr) {
        await transport.setDtr(true);
    }
    if (setRts) {
        await transport.setRts(true);
    }
    try {
        await initLogic();
    }
    finally {
        if (setRts) {
            await transport.setRts(false);
        }
        if (setDtr) {
            await transport.setDtr(false);
        }
    }
}
//# sourceMappingURL=lineControl.js.map